import useNativeListener from '@hooks/native/useNativeListener';

export type DeepLinkType =
    'EVENT'
    | 'NOTICE'
    // | 'FREQUENCY_EVENT'
    | 'COUPON_BOX'
    | 'STAMP'
    | 'ITEMS'
    | 'GIFT_BOX'
    | 'PREPAID_CARD'
    | 'ETC'
    | 'PREPAID_CARD_GIFT_BOX';

export interface OnDeepLinkReceivedParams {
    deepLinkType: DeepLinkType;
    eventId?: string;
    noticeId?: string;
    shopId?: string;
}

function useDeepLinkListener(
    func: (params: OnDeepLinkReceivedParams) =>void,
    deps?: any[],
) {
    return useNativeListener(
        'onDeepLinkReceive',
        func,
        [...(deps || [])],
    );
}

export default useDeepLinkListener;
